export const CloseButton = {
  baseStyle: {
    borderRadius: '4px',
    _focus: {
      boxShadow: 'none',
      outline: 'none',
    },
  },
};
